import React from "react";

export default function Hero() {
  return (
    <>
      <header className="sz-hero">
        <div className="container">
          <h1>Platform User Guidelines &amp; Comprehensive Guide</h1>
          <p>
            Everything you need to know about using Selectezi responsibly,
            growing your business network, troubleshooting technical steps,
            and connecting with our team.
          </p>
        </div>
      </header>

      <div className="container">
        <div className="sz-intro-card">
          <h3>
            <span className="sz-intro-bar" /> User Guidelines
          </h3>
          <p>
            Welcome to our platform, a digital network where individuals and
            businesses connect, interact, and grow.
          </p>
          <p>
            These User Guidelines are designed to help you understand how to
            use our platform responsibly and in accordance with our values of
            trust, transparency, and professionalism.
          </p>
          <p className="mb-0">
            By accessing or using our services, you agree to follow these
            guidelines in addition to our Terms and Conditions and Privacy
            Policy.
          </p>
        </div>
      </div>
    </>
  );
}
